import fetch from './fetch'
import { format } from '@/web-task/filter'

class DispatchApi {
	public createRule(form: any) {
		return fetch({
			url: 'injury/rule/create',
			method: 'post',
			data: form,
		})
	}

	public updateRule(form: any) {
		return fetch({
			url: '/injury/rule/update',
			method: 'post',
			data: form,
		})
	}

	public checkUnique(form: any) {
		return fetch({
			url: '/injury/rule/checkRepeat',
			method: 'post',
			data: form,
		})
	}
}

export default new DispatchApi()
